import type { RewardSpecDTO, ReceivedItemDTO } from '../types/dto'
import type { Reward, ReceivedItem, BoosterReward } from '../types/domain'

export const fromRewardSpecDTO = (dto: RewardSpecDTO): Reward => {
  if (dto.subType === 'booster' && dto.options.boost) {
    const boosterReward: BoosterReward = {
      type: 'inventory_item',
      subType: 'booster',
      quantity: dto.quantity,
      options: {
        activationType: (dto.options.activationType || 'auto') as 'auto' | 'manual',
        boost: {
          value: dto.options.boost.value,
          unit: dto.options.boost.unit as 'percentage' | 'fixed'
        }
      }
    }
    return boosterReward
  }

  const defaultBoosterReward: BoosterReward = {
    type: 'inventory_item',
    subType: 'booster',
    quantity: dto.quantity,
    options: {
      activationType: 'manual',
      boost: {
        value: 0,
        unit: 'percentage'
      }
    }
  }
  return defaultBoosterReward
}

export const fromReceivedItemDTO = (dto: ReceivedItemDTO): ReceivedItem => ({
  id: dto.id,
  status: dto.status
})
